import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';


@Injectable({providedIn: 'root'})
export class AuthGuardService  {
    sub: Subscription;

    constructor(private oauthService: OAuthService, public router: Router) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if(this.oauthService.hasValidAccessToken()) {
            if(state?.url.indexOf("standard/details") > -1)
            localStorage.setItem("gs1-ecli-standard-state", state?.url);

            
           /*  if(state?.url.indexOf("factures") > -1)
            localStorage.setItem("gs1-ecli-route-state", state?.url); */

            if(state?.url.indexOf("/apim/connexion") > -1)
            localStorage.setItem("gs1-ecli-state-apim", state?.url);
            if( state?.url.indexOf("operation=SignOut") > -1)
            {
                localStorage.removeItem("gs1-ecli-state-apim");
                this.router.navigateByUrl('/');
            }
            return true;
        } else {
            const refusedAccess = {
                url: state.url,
                date: Date.now()
            }
            localStorage.setItem("gs1-ecli-previous-state", JSON.stringify(refusedAccess));
            this.router.navigate(['autologin']);
            return false;
        }
    }
}